export { JiraIssueCollectorEntryPoint } from './scope';
